export default {
  NOTIFICATION_ROUTES: {
    'Actualizaciones': 'actualizacion',
    'Comunicaciones': 'detalleBoletin',
    'Consultas': 'detalleConsulta',
    'Contratos': 'detalleContrato',
    'Eventos': 'detalleEvento',
    'Expedientes': 'detalleExpediente',
    'Jugadores': 'detalleJugador',
    'liquidación tv': 'detalleLiquidacion',
    'liquidación jugadores': 'detalleLiquidacionJugador',
    'Presentaciones': 'presentacion',
    'Informe_pagos': 'informe-pagos',
    'Deudas_entre_clubes': 'detalleDeuda',
    'Informes_auditorias': 'informe-auditoria'
  }
}
